import { checkUseAccessLevel } from "@/Hooks/utils";
import { useContext } from "react";
import { ParentContext } from "../store/context/ParentContext";
import { UserData } from "@/Contracts";

const useAccessLevel = (id: string | null | undefined): boolean => {
	const parentContext = useContext(ParentContext);
	return checkUseAccessLevel(parentContext.user.userData as UserData)(id);
};

export default useAccessLevel;
